// @flow
import * as React from 'react';
import { translate } from 'react-i18next';

import TitledCard from 'common/components/cards/TitledCard';
import ActionBar from '../components/ActionBar';

type Props = {
  onButtonClick: () => void,
  t: any,
}

function Introduction(props: Props) {
  return (
    <TitledCard title={props.t('intro')}>
      <p>
        Spicy jalapeno bacon ipsum dolor amet shankle labore sunt fugiat bacon buffalo short loin cow dolor do.
        Mollit voluptate tri-tip ullamco shankle capicola lorem aute qui salami ut commodo short ribs prosciutto fatback. Cupidatat pariatur swine meatball tempor chuck.
        In swine porchetta, adipisicing filet mignon non tri-tip magna frankfurter drumstick.
        Ball tip ut ut, biltong aute tail short ribs consequat prosciutto leberkas venison nulla eiusmod cillum. In dolor turkey pastrami eiusmod sunt anim ex.
        In pancetta bacon beef, drumstick do pork belly porchetta beef ribs. Swine elit ut nisi.
        Aute occaecat quis in in consectetur est pariatur ball tip. Capicola lorem in dolore flank, pariatur venison.
        Aliquip boudin occaecat esse, mollit anim pork belly tri-tip leberkas ea.
        Laboris veniam elit consequat beef ut meatball voluptate t-bone deserunt dolore. Eu tri-tip deserunt minim aliquip. Sirloin spare ribs short loin burgdoggen cupidatat.
        Jowl chicken excepteur culpa capicola, consequat magna proident voluptate filet mignon fugiat andouille brisket aute tri-tip.
      </p>
      <ActionBar onActionClick={props.onButtonClick} actionText={props.t('begin')} />
    </TitledCard>
  );
}

export default translate('radioConfiguration')(Introduction);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/Introduction.js